import { WithdrawViewModalManual } from 'features/withdraw/components/modal/withdraw-admin-manual';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
// ../components/modal/withdraw-admin-manual
// ../components/modal/super-admin-manual

export const WithdrawViewManual = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.WITHDRAW);
  };

  return (
    <WithdrawViewModalManual
      id={id}
      onClose={closeModal}
      onSuccess={closeModal}
    />
  );
};
